/**
 * AutoMapa fair-price constants (Milestone 9).
 *
 * Buyer-safe language only — avoid: valor real, tasación oficial, precio exacto,
 * garantizado, certificado por AutoMapa (unless actually certified).
 */
export { FAIR_PRICE_ANALYTICS_EVENTS } from "./automapAnalyticsEvents";

export const FAIR_PRICE_LABELS = {
  below_market: "below_market",
  fair_price: "fair_price",
  slightly_high: "slightly_high",
  high_price: "high_price",
  not_enough_data: "not_enough_data",
  unknown: "unknown",
};

export const FAIR_PRICE_LABELS_ES = {
  below_market: "Por debajo del mercado",
  fair_price: "Precio justo",
  slightly_high: "Un poco alto",
  high_price: "Precio alto",
  not_enough_data: "Sin suficientes datos",
  unknown: "Sin evaluación",
};

/** Shorter labels for compact search cards */
export const FAIR_PRICE_SHORT_LABELS_ES = {
  below_market: "Buen precio",
  fair_price: "Precio justo",
  slightly_high: "Un poco alto",
  high_price: "Precio alto",
  not_enough_data: "Sin datos",
  unknown: "Sin evaluación",
};

export const FAIR_PRICE_EXPLANATIONS_ES = {
  below_market:
    "AutoMapa compara esta publicación con vehículos parecidos cuando hay suficientes datos disponibles.",
  fair_price:
    "La publicación está cerca de referencias similares disponibles en AutoMapa.",
  slightly_high:
    "Puede valer la pena comparar condiciones, kilometraje, versión, historial y negociación.",
  high_price:
    "Revisa el estado del vehículo, kilometraje, documentos y opciones similares antes de decidir.",
  not_enough_data:
    "AutoMapa necesita más publicaciones similares para mostrar una referencia de precio confiable.",
  unknown:
    "No tenemos información suficiente para mostrar una referencia de precio.",
};

export const FAIR_PRICE_DETAIL_TITLES_ES = {
  below_market: "Este precio parece estar por debajo de publicaciones similares",
  fair_price: "Este precio parece estar dentro de un rango justo",
  slightly_high: "Este precio parece un poco alto",
  high_price: "Este precio parece alto frente a comparables",
  not_enough_data: "Aún no hay suficientes comparables",
  unknown: "Sin evaluación de precio",
};

export const FAIR_PRICE_METHODOLOGY_ES =
  "AutoMapa compara publicaciones similares por marca, modelo, año, precio, ciudad, kilometraje y otros datos disponibles. Esta referencia no reemplaza una inspección, negociación ni revisión documental.";

export const FAIR_PRICE_DISCLAIMER =
  "Estimación basada en publicaciones disponibles en AutoMapa. Puede variar por estado, versión, historial, financiación, ubicación y negociación.";

export const FAIR_PRICE_CLASS = {
  below_market: "green",
  fair_price: "green",
  slightly_high: "amber",
  high_price: "red",
  not_enough_data: "gray",
  unknown: "gray",
};

export const FAIR_PRICE_CONFIDENCE_ES = {
  high: "alta",
  medium: "media",
  low: "baja",
};

export const RECOMMENDATION_FAIR_PRICE_BOOST = {
  below_market: 8,
  fair_price: 6,
  slightly_high: 1,
  high_price: -5,
  not_enough_data: 0,
  unknown: 0,
};
